import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {PopupField} from '../general_details/header_details/PopupField.jsx';
import {UnitOfMeasurePopup} from './UnitOfMeasurePopup.jsx';
import {BrickContext} from 'olympe';

/**
 * Delivery address field:
 *  - disabled text field with an adornment button that open the popup
 *  - a popup that split the address in many fields and regroup them on save
 * @param {!Object} props
 * @return {JSX.Element}
 */


export const UnitOfMeasureFieldWithPopup = (props) => {
    const [open, setOpen] = useState(false);

    return (<>
        <PopupField
            value={props.value}
            onOpen={() => setOpen(true)}
            canEdit={!props.disabled}
            property={'Unit of Measure'}
        />
        {
            !props.disabled &&
            <UnitOfMeasurePopup
                context={props.context}
                prTag={props.prTag}
                open={open}
                materialNumber={props.materialNumber}
                {...props}
                onSave={(UoM) => {
                    setOpen(false);
                    props.onSave(UoM);
                }}
                onCancel={() => {
                    setOpen(false);
                }}
            />
        }
    </>);
};

UnitOfMeasureFieldWithPopup.propTypes = {
    context: PropTypes.instanceOf(BrickContext).isRequired,
    prTag: PropTypes.string.isRequired,
    value: PropTypes.string,
    onSave: PropTypes.func,
    disabled: PropTypes.bool,
    unitOptions: PropTypes.array,
    leftValue: PropTypes.number,
    materialNumber: PropTypes.string.isRequired,
};


